<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">OA审批-整体调薪申请</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div
                style="height:680px;background-color:white;margin:75px 40px 0 40px;padding:40px 60px;overflow-x: hidden">
                <!-- 查询框 -->
                <span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
                <span style="font-size:20px;font-weight:700">调薪信息</span>
                <div style="border:1px solid #DADADA;margin-top:10px"></div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调薪部门:" prop="name" style="margin-top:40px">
                                {{ tableData.organize_name }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="调薪人员:" prop="name" style="margin-top:40px">
                                {{ tableData.change_staff_name }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调薪时间:" prop="name">
                                {{ tableData.change_date }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="调薪类型:" prop="name">
                                {{ tableData.dictionaries_data }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="金额:" prop="name">
                                {{ tableData.change_money }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="调薪原因:" prop="name">
                                {{ tableData.change_reason }}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div style="margin-top:20px;">
                       <el-row v-show="is_reviewer_state == 0">
                       	<el-col style="margin:20px 40%;">
                       		<el-button type="goon" @click="$refs['examine'].save(id, 1)">同意</el-button>
                       		<el-button type="addbtn" @click="$refs['examine'].reject(id)">驳回</el-button>
                       	</el-col>
                       </el-row>
                    </div>
                </el-form>

            </div>

        </div>
        <examine ref="examine" :spare="spare" :id="id"></examine>
    </div>
</template>

<script>
import examine from "./OA_examine.vue";
export default {
    components: {
        examine: examine,
    },
    props: ["editData", "id", "reviewer_state","is_reviewer_state"],
    data() {
        return {
			tableData:[],
		};
    },
	created() {
		console.log(this.editData)
	},
    methods: {
        submitForm() {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
		async edit() {
			var result = await this.$globals.AxiosPost("examine/DetailsFind", {
				examine_id: this.editData.examine_id,
				examine_type: this.editData.examine_type
			});
			this.tableData = result.data.detailed;
		
		},
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        Return() {
            this.$parent.Return();
        }
    }
}
</script>

<style>
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    content: '';
}
</style>



// WEBPACK FOOTER //
// QAsp_txsq.vue?48f34962